import { PolicyActionTypes } from './policy.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addPolicySuccess: null,
    addPolicyError: null,
    addPolicyReqStatus: '',
    policyListSuccess: null,
    policyListError: null,
    policyDetailSuccess: null,
    policyDetailError: null,
    assignPolicySuccess: null,
    assignPolicyError: null,
    assignPolicyReqStatus: '',
    policyMarkCompleteSuccess: null,
    policyMarkCompleteError: null,
    policyMarkCompleteReqStatus: ''
}

const policyReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PolicyActionTypes.ADD_POLICY_REQUEST_SUCCESS:
            return {
                ...state,
                addPolicySuccess: action.payload,
                addPolicyError: null,
                addPolicyReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PolicyActionTypes.ADD_POLICY_REQUEST_ERROR:
            return {
                ...state,
                addPolicySuccess: null,
                addPolicyError: action.payload,
                addPolicyReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PolicyActionTypes.ADD_POLICY_REQUEST_STATUS:
            return {
                ...state,
                addPolicyReqStatus: ''
            }
        case PolicyActionTypes.POLICY_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                policyListSuccess: action.payload,
                policyListError: null
            }
        case PolicyActionTypes.POLICY_LIST_REQUEST_ERROR:
            return {
                ...state,
                policyListSuccess: null,
                policyListError: action.payload
            }
        case PolicyActionTypes.POLICY_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                policyDetailSuccess: action.payload,
                policyDetailError: null
            }
        case PolicyActionTypes.POLICY_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                policyDetailSuccess: null,
                policyDetailError: action.payload
            }
        case PolicyActionTypes.ASSIGN_POLICY_REQUEST_SUCCESS:
            return {
                ...state,
                assignPolicySuccess: action.payload,
                assignPolicyError: null,
                assignPolicyReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PolicyActionTypes.ASSIGN_POLICY_REQUEST_ERROR:
            return {
                ...state,
                assignPolicySuccess: null,
                assignPolicyError: action.payload,
                assignPolicyReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PolicyActionTypes.ASSIGN_POLICY_REQUEST_STATUS:
            return {
                ...state,
                assignPolicyReqStatus: ''
            }
        case PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST_SUCCESS:
            return {
                ...state,
                policyMarkCompleteSuccess: action.payload,
                policyMarkCompleteError: null,
                policyMarkCompleteReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST_ERROR:
            return {
                ...state,
                policyMarkCompleteSuccess: null,
                policyMarkCompleteError: action.payload,
                policyMarkCompleteReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case PolicyActionTypes.POLICY_MARK_COMPLETE_REQUEST_STATUS:
            return {
                ...state,
                policyMarkCompleteReqStatus: ''
            }
        case PolicyActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default policyReducer